import { NSARouterMakerResult } from "namirasoft-account-react";
import { FilterItem, FilterItemOperator } from "namirasoft-core";
import { ProviderRow } from "namirasoft-email-sender";
import { NamirasoftMap } from "namirasoft-site-map";
import { NSBox, NSBoxEmail, NSBoxEntity, NSBoxString, NSBoxTextArea, NSButtonBlue, NSColumn, NSPanel, NSRow } from "namirasoft-site-react";
import { useRef } from "react";
import { useParams } from "react-router-dom";
import { EmailSenderLayout } from "../EmailSenderLayout";
import { EmailSenderRouterProps } from "../EmailSenderRouterProps";
import { EmailSenderRoutes } from "../EmailSenderRoutes";
import Styles from "./SendPage.module.css";

export interface ISendPageProps extends NSARouterMakerResult, EmailSenderRouterProps { }

function SendPage(props: ISendPageProps)
{
	let NSBoxEmail_Email = useRef<NSBoxEmail>(null);
	let NSBoxString_Title = useRef<NSBoxString>(null);
	let NSBoxTextarea_Message = useRef<NSBoxTextArea>(null);
	let NSBoxEntity_Provider = useRef<NSBoxEntity<ProviderRow>>(null);

	let { id } = useParams();

	let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

	return (
		<EmailSenderLayout {...props}
			action={{
				title: "Send",
				description: "Enter the destination email address and your message to send an email via the selected provider.",
				menus: {}
			}}
		>
			<NSPanel classList={["mx-auto"]}>
				<NSColumn style={{ width: NSBox.width.double }}>
					<NSRow>
						<NSBoxEntity<ProviderRow>
							ref={NSBoxEntity_Provider}
							title="Provider"
							required
							multiple={false}
							table={namirasoft.email_sender.tables.provider}
							getValue={item => item.id}
							getTitle={item => item.name}
							getSort={() => null}
							onLoaded={() =>
							{
								if (id)
									NSBoxEntity_Provider.current?.setValue(id);
							}}
                            info={{ link: "https://namirasoft.com/email-sender/console-guide/send/#field-provider" }}
						/>
						<NSBoxEmail
							ref={NSBoxEmail_Email}
							title="Email"
							classList={[Styles.send_page_email]}
							required
                            info={{ link: "https://namirasoft.com/email-sender/console-guide/send/#field-email" }}
						/>
					</NSRow>
					<NSBoxString
						ref={NSBoxString_Title}
						title="Title"
						classList={[Styles.send_page_email]}
						required
                        info={{ link: "https://namirasoft.com/email-sender/console-guide/send/#field-title" }}
						style={{ width: "100%" }}
					/>
					<NSBoxTextArea
						ref={NSBoxTextarea_Message}
						title="Message"
						required
						placeholder="Write your Message"
                        info={{ link: "https://namirasoft.com/email-sender/console-guide/send/#field-message" }}
						style={{ width: "100%" }}
					/>
					<NSRow>
						<NSButtonBlue title="Apply" onClick={{
							showLoading: true,
							action: async (onFinshied) =>
							{
								let provider_id: string;
								let email: string;
								let title: string;
								let message: string;
								try
								{
									let selected_provider_id = NSBoxEntity_Provider.current?.getValueOne();
									if (!selected_provider_id)
									{
										onFinshied();
										return;
									}
									provider_id = selected_provider_id;
									email = NSBoxEmail_Email.current?.getValue() ?? "";
									title = NSBoxString_Title.current?.getValue() ?? "";
									message = NSBoxTextarea_Message.current?.getValue() ?? "";
								} catch (error)
								{
									// Input validation errors are not reported by the server, so notify here.
									props.notifier.onError(error as Error);
									onFinshied();
									return;
								}

								try
								{
									let res = await props.servers.email_sender.email.Send({ provider_id, email, title, message, html: false });
									props.notifier.onSuccess("An email was sent successfully");

									let filters = [new FilterItem(namirasoft.email_sender.tables.sent, namirasoft.email_sender.tables.sent.columns.id, false, FilterItemOperator.all.equals, res.id)];
									props.url.redirect(EmailSenderRoutes.SentList, { filters: FilterItem.encode(filters) });
									onFinshied();
								} catch
								{
									// The server already reported the error through the notifier.
									onFinshied();
								}
							}
						}} />
					</NSRow>
				</NSColumn>
			</NSPanel>
		</EmailSenderLayout>
	);
}

export default SendPage;